import gql from 'graphql-tag'

export const SIGN_IN_USER = gql`
mutation ($input: SignInUserInput!) {
  signInUser(input: $input) {
    user {
      id
    }
    errors
  }
}
`

export default {
  SIGN_IN_USER
}
